import React from 'react';

// 3D-looking premium SVG Token Renderer with Gold Pedestal & Radial Gradient Shading
export const TokenIcon = ({ token, color, size = 22 }) => {
  let t = token;
  if (t === 'Car') t = 'KirmiziAraba';
  if (t === 'Ship') t = 'Vapur';
  if (t === 'Hat') t = 'Gevrek';
  if (t === 'Dog') t = 'Marti';
  if (t === 'Shoe') t = 'Boyoz';

  const tokenEmojis = {
    'Vapur': '🚢',
    'SaatKulesi': '🕰️',
    'Marti': '🕊️',
    'Boyoz': '🥐',
    'NazarBoncugu': '🧿',
    'Palmiye': '🌴',
    'KirmiziAraba': '🚗',
    'Gevrek': '🥯'
  };

  const emoji = tokenEmojis[t] || '🎲';
  const glowColor = color || '#fbbf24';

  const sizeStyle = typeof size === 'number'
    ? {
        fontSize: `${size * 0.9}px`,
        width: `${size}px`,
        height: `${size}px`
      }
    : {
        fontSize: `calc(${size || '22px'} * 0.9)`,
        width: size || '22px',
        height: size || '22px'
      };

  return (
    <span 
      className="emoji-token-icon" 
      style={{ 
        ...sizeStyle,
        lineHeight: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        filter: `drop-shadow(0 3px 5px rgba(0,0,0,0.5)) drop-shadow(0 0 3px ${glowColor}70)`,
        userSelect: 'none',
        verticalAlign: 'middle',
        transition: 'transform 0.2s ease, filter 0.2s ease'
      }}
    >
      {emoji}
    </span>
  );
};

export default TokenIcon;
